import { createFileRoute } from '@tanstack/react-router';
import { useRegistrationGuard } from '@/hooks/use-registration-guard';
import { STEPS } from '@/features/cleaner/apply-cleaner/constant';
import { CleanerSignupStep } from '@/features/cleaner/apply-cleaner/steps/cleaner-signup-step';

function SignupRoute() {
  useRegistrationGuard({
    requiredStep: STEPS.SIGNUP_CLEANER,
    requireAuth: false,
  });

  return <CleanerSignupStep />;
}

export const Route = createFileRoute('/(cleaner)/apply-cleaner/signup')({
  component: SignupRoute,
});
